const initialDueDiligence = ['verified', 'unverified'];

export { initialDueDiligence };
